(() => {
  const dialog = document.querySelector('[data-email-capture]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const storageKey = 'hwlEmailCaptureDismissedAt';
  const dismissedRecently = () => {
    try {
      const dismissedAt = Number(localStorage.getItem(storageKey));
      return dismissedAt && Date.now() - dismissedAt < Number(dialog.dataset.dismissalDays) * 86400000;
    } catch (_error) { return false; }
  };
  const open = () => {
    if (dialog.open) return;
    dialog.showModal();
    window.requestAnimationFrame(() => dialog.querySelector('input[type="email"], button')?.focus());
  };
  const dismiss = () => {
    try { localStorage.setItem(storageKey, String(Date.now())); } catch (_error) {}
    dialog.close();
  };
  dialog.querySelectorAll('[data-email-capture-close]').forEach((button) => button.addEventListener('click', dismiss));
  dialog.addEventListener('click', (event) => {
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dismiss();
  });
  dialog.addEventListener('cancel', (event) => { event.preventDefault(); dismiss(); });
  document.addEventListener('click', (event) => {
    if (event.target.closest('a[href="#EmailCaptureDialog"]')) { event.preventDefault(); open(); }
  });
  if (dialog.dataset.forceOpen === 'true' || window.location.hash === '#EmailCaptureDialog') open();
  else if (dialog.dataset.enabled === 'true' && !dismissedRecently()) window.setTimeout(open, Number(dialog.dataset.delay));
})();
